module.exports = __webpack_public_path__ + "static/brand_logo-50a4aed68da021b00870ae68e409244f.png";